<template>
    <div class="quiz-dashboard">
        <div class="quiz-dashboard__top-section">
            <div class="quiz-dashboard__top-wrapper kasanowa-desktop"></div>
            <div class="quiz-dashboard__top-box-wrapper">
                <img src="~@/assets/images/money.png" alt="kasanowa" />
                <div class="quiz-dashboard__top-title-wrapper">{{ $t('quiz.moneyForQuiz') }}</div>
                <div class="quiz-dashboard__item-wrapper">
                    <div class="quiz-dashboard__money">{{ userInfo?.money_to_get || '0.00' }} PLN</div>
                    <div>
                        <div class="quiz-dashboard__text quiz-dashboard__text--large">{{ $t('quiz.dashboardDescription0') }}</div>
                        <div class="quiz-dashboard__text">{{ $t('quiz.dashboardDescription1') }} <span>{{ $t('quiz.dashboardDescription2') }}</span> </div>
                    </div>
                </div>
                <div class="quiz-dashboard__btn-wrapper">
                    <KButton
                        id="quiz"
                        :label="$t('quiz.play')"
                        icon="arrowRight"
                        type="submit"
                        :color="black"
                        uppercase
                        @click="goToQuiz"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { navigateTo } from '@/hooks/NavigateHooks';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import variables from '@/assets/scss/modules/variables.module.scss';
import KButton from '@/components/atoms/KButton.vue';

const { black } = variables;
const { userInfo } = storeToRefs(useUserStore());

const goToQuiz = () => {
    navigateTo('/quiz-ph');
};
</script>

<style scoped lang="scss">
.quiz-dashboard {
    position: relative;
    padding-bottom: 80px;

    @include media-breakpoint-up(lg) {
        padding-bottom: 200px;
    }

    &__top-section {
        padding-top: 70px;

        @include media-breakpoint-up(lg) {
            padding-top: 146px;
        }
    }

    &__top-wrapper {
        @include media-breakpoint-up(lg) {
            width: 20%;
        }
    }

    &__top-box-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        max-width: 872px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        border: 1px solid $primary-400;
        background: rgba($primary-400, 0.6);
        backdrop-filter: blur(2px) saturate(150%);
        -webkit-backdrop-filter: blur(5px) saturate(150%);
        padding: 36px 16px;

        @include media-breakpoint-up(lg) {
            width: 80%;
            padding: 50px 16px;
        }

        img {
            position: absolute;
            bottom: -60px;
            max-width: 235px;
            max-height: 352px;

            @include media-breakpoint-up(lg) {
                left: 40px;
                bottom: -90px;
            }
        }
    }

    &__money {
        font-size: 32px;
        color: $white;
        font-weight: 900;
        letter-spacing: 0;

        @include media-breakpoint-up(md) {
            font-size: 60px;
        }

        @include media-breakpoint-up(xl) {
            font-size: 72px;
        }
    }

    &__text {
        color: $white;
        text-align: center;

        @include media-breakpoint-up(lg) {
            text-align: left;
            line-height: 1.1;
        }

        &--large {
            font-size: 24px;
            font-weight: 700;
            text-transform: uppercase;

            @include media-breakpoint-up(lg) {
                font-size: 36px;
            }
        }

        span {
            font-weight: 700;
            color: $primary-400;
        }
    }

    &__top-title-wrapper {
        position: absolute;
        top: -40px;
        left: 50%;
        transform: translateX(-50%);
        width: max-content;
        background-color: $primary-400;
        font-weight: 900;
        color: $black;
        font-size: 35px;
        padding: 0 14px;
        letter-spacing: 0;
        text-transform: uppercase;

        @include media-breakpoint-up(lg) {
            font-size: 52px;
            padding: 0 55px;
            top: -40px;
        }
    }

    &__btn-wrapper {
        margin-top: 20px;
        margin-bottom: 80px;

        @include media-breakpoint-up(lg) {
            margin-top: 40px;
            margin-bottom: 0;
        }
    }

    &__item-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
            align-items: center;
            gap: 30px;
            margin-top: 40px;
        }
    }
}
</style>
